export async function getSrcFromFile(file) {
    // Se il file è un'immagine, convertilo in un'immagine e imposta l'immagine
    if (file.type.startsWith('image')) {
        const image = await convertFileToImage(file);
        return image.src;
    }
}

// Funzione per convertire un file in un'immagine
function convertFileToImage(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const naturalWidth = img.naturalWidth;
                const src = img.src;
                resolve({ src, width, height, naturalWidth });
            };
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export function assembleMediahostUrl(src, coords) {
    if (!src?.startsWith(`${MEDIA_URL}`)) return src;
    const { x = 0, y = 0, zoom = 1, containerWidth = 480 } = coords;

    const url = new URL(src);
    url.searchParams.set('x', Math.abs(Math.round(x)));
    url.searchParams.set('y', Math.abs(Math.round(y)));
    url.searchParams.set('w', Math.round(containerWidth));
    url.searchParams.set('h', 270);
    if (zoom !== 1) url.searchParams.set('z', zoom.toFixed(2));
    return url.toString();
}

// Molti URL di immagini non hanno estensione (es. CDN con query string): il formato reale lo verifica l'API dal content-type
export function isHttpUrl(value) {
    try {
        return ['http:', 'https:'].includes(new URL(value).protocol);
    } catch {
        return false;
    }
}
